import { ServiceSearchModel } from '../../models/services/serviceSearch';
import * as ServiceModels from '../../models/services/service';
import * as Models from '../../models/commonModels';

export class GetServiceList {
  static readonly type = '[Service]  [Service]GetServiceList';
  constructor(public Search: ServiceSearchModel) { }
}

export class GetServiceTypeDictionary {
  static readonly type = '[Service] ServiceTypeDictionary';
  constructor() { }
}

export class GetService {
  static readonly type = '[Service] GetService';
  constructor(public ServiceId: number) { }
}

export class Refresh {
  static readonly type = '[Service] Refresh';
  constructor(public Service: ServiceModels.ServiceModel) { }
}


export class SetNotDefinePriceServiceCommission {
  static readonly type = '[Service] SetNotDefinePriceServiceCommission';
  constructor(public Commision: number) { }
}


export class SetServiceSearch {
  static readonly type = '[Service] SetServiceSearch';
  constructor(public Search: ServiceSearchModel) { }
}

export class ResetServiceSearch {
  static readonly type = '[Service] ResetServiceSearch';
  constructor() { }
}

export class SetServiceListPage {
  static readonly type = '[Service] SetServiceListPage';
  constructor(public Search: ServiceSearchModel) { }
}

export class DeleteServiceItem {
  static readonly type = '[Service] DeleteServiceItem';
  constructor(public ServiceId: number) { }
}


export class DuplicateServiceItem {
  static readonly type = '[Service] DuplicateServiceItem';
  constructor(public ServiceId: number) { }
}

export class Insert {
  static readonly type = '[Service] Insert';
  constructor(public Service: ServiceModels.ServiceModel) { }
}

export class Set {
  static readonly type = '[Service] Set';
  constructor(public Service: ServiceModels.ServiceModel) { }
}

export class DisposeSearch {
  static readonly type = '[Service] DisposeSearch';
  constructor() { }
}

export class GetCustomerGarageServicePriceList {
  static readonly type = '[Service] GetCustomerGarageServicePriceList';
  constructor(public Search: ServiceModels.CustomerGarageServicePriceSearchModel) { }
}

export class SetCustomerGarageServicePriceListPage {
  static readonly type = '[Service] SetCustomerGarageServicePriceListPage';
  constructor(public Search: ServiceModels.CustomerGarageServicePriceSearchModel) { }
}

export class ResetCustomerGarageServicePriceList {
  static readonly type = '[Service] ResetCustomerGarageServicePriceList';
  constructor() { }
}

export class SetCustomerGarageServicePriceSearch {
  static readonly type = '[Service] SetCustomerGarageServicePriceSearch';
  constructor(public Search: ServiceModels.CustomerGarageServicePriceSearchModel) { }
}

export class SetCustomerGarageServicePrice {
  static readonly type = '[Service] SetCustomerGarageServicePrice';
  constructor(public SaveServiceList: Models.Request<ServiceModels.SetCustomerGarageServicePriceModel>) { }
} 

export class ClearCustomerGarageServicePrice {
  static readonly type = '[Service] ClearCustomerGarageServicePrice';
  constructor(public Search: ServiceModels.CustomerGarageServicePriceSearchModel) { }
} 

export class GetGarageServicePriceExcelReport  {
  static readonly type = "[Service] GetGarageServicePriceExcelReport";
  constructor(public Search: Models.RequestModel) { }
}

export class GetGarageServicePricePdfReport {
  static readonly type = "[Service] GetGarageServicePricePdfReport";
  constructor(public Search: Models.RequestModel) { }
} 

export class ImportGarageServicePriceList {
  static readonly type = '[Service] ImportGarageServicePriceList';
  constructor(public FileName: string, public Data: any) { }
}

export class SetImportGarageServicePriceListStatus {
  static readonly type = '[Service] SetImportGarageServicePriceListStatus';
  constructor(public Status: boolean) { }
}
 
export class SendEmailGarageServicePricePdfReport {
  static readonly type = "[Service] SendEmailGarageServicePricePdfReport";
  constructor(public Search: Models.RequestModel) { }
}

export class GetGarageServicePriceAnalyticExcelReport {
  static readonly type = "[Service] GetGarageServicePriceAnalyticExcelReport";
  constructor(public Search: Models.RequestModel) { }
}
